import { TransactionBaseModel, TransactionTypeModel, } from '@neo-one/client-common';
import { InvalidVersionError } from '../../errors';
export class IssueTransactionModel extends TransactionBaseModel {
    constructor({ version, attributes, inputs, outputs, scripts, hash, }) {
        super({
            version,
            type: TransactionTypeModel.Issue,
            attributes,
            inputs,
            outputs,
            scripts,
            hash,
        });
        if (this.version > 1) {
            throw new InvalidVersionError(1, this.version);
        }
    }
    clone({ scripts = this.scripts, attributes = this.attributes, inputs = this.inputs, outputs = this.outputs, }) {
        return new this.constructor({
            version: this.version,
            attributes,
            inputs,
            outputs,
            scripts,
        });
    }
}
IssueTransactionModel.VERSION = 1;

//# sourceMappingURL=IssueTransactionModel.js.map
